<template>
  <div v-show="isAvailable" ref="container" class="tw:!w-full tw:!min-h-[1rem] tw:!mt-4"></div>
</template>

<script setup lang="ts">
import { onMounted, ref, nextTick } from 'vue'
import type { PaymentIntent, Stripe } from '@stripe/stripe-js'
import { useStripe } from '~/composables/usePayment'


const props = defineProps<{
  clientSecret: string
  amount: number
  email?: string
}>()

const emit = defineEmits<{
  success: [paymentIntent: PaymentIntent]
  unavailable: []
}>()

const container = ref<HTMLDivElement>()
const isAvailable = ref(false)

onMounted(async () => {
  const stripe = await useStripe() as Stripe

  const paymentRequest = stripe.paymentRequest({
    country: 'US',
    currency: 'usd',
    total: {
      label: 'eSIM Data Package',
      amount: Math.round(props.amount / 100),
    },
    requestPayerEmail: true,
  })

  const canMake = await paymentRequest.canMakePayment()
  if (!canMake) {
    emit('unavailable')
    return
  }

  isAvailable.value = true


  const elements = stripe.elements()
  const prButton = elements.create('paymentRequestButton', {
    paymentRequest,
    style: {
      paymentRequestButton: {
        type: 'default',
        theme: 'dark',
        height: '48px',
      },
    },
  })

  await nextTick()
  prButton.mount(container.value!)

  paymentRequest.on('paymentmethod', async (ev) => {
    const { paymentIntent } = await stripe.confirmCardPayment(
      props.clientSecret,
      { payment_method: ev.paymentMethod.id },
      { handleActions: false }
    )
    
    if (paymentIntent?.status === 'requires_action') {
      await stripe.confirmCardPayment(props.clientSecret)
    }

    emit('success', paymentIntent!)
  })
})
</script>